module.exports = __webpack_public_path__ + "image/favicon.048c9143.ico";